import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: false
})
export class TermsConditionsComponent implements OnInit {

  constructor() { 
     //Empty constructor for future use.
  }

  ngOnInit(): void {
    //Empty method for future use.
  }

}
